import styled from 'styled-components';
import { Link } from '../../../../../../components/Link/Link';
import { Gray, Shade } from '../../../../../../constants/styles';
export const Container = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 2fr;
  grid-column-gap: 60px;
  padding: 40px 15px 80px 120px;
  max-width: 1270px;
  margin-left: auto;
  margin-right: auto;
`;
export const ImageLinkWrapper = styled.div `
  display: flex;
  align-items: center;
  height: 100%;
`;
export const StyledImageLink = styled(Link) `
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
  text-decoration: none;
  box-shadow: ${Shade.x500};
  padding: 5px;

  &:hover {
    text-decoration: underline;
  }
`;
export const ImageTitle = styled.span `
  color: ${Gray.x100};
  display: block;
  font-size: ${({ theme }) => theme.fontSizes.sizeSm3};
  font-weight: 300;
  padding: 4px 0 6px 7px;
`;
export const ColumnDivider = styled.div `
  background-color: ${Gray.x200};
  margin: 35px 0 5px;
  width: 1px;
`;
export const FeaturedColumn = styled.div `
  width: 100%;
`;
export const FeaturedColumnInner = styled.div `
  display: grid;
  justify-content: end;
`;
//# sourceMappingURL=ComicGameWorldsPanel.styled.js.map